/*
 * UNIVERSIDAD AUTONOMA DE AGUASCALIENTES
 * DIRECCION GENERAL DE PLANEACION Y DESARROLLO
 * DEPARTAMENTO DE SISTEMAS (OPTIMIZACION DE PROYECTOS ADMINISTRATIVOS - OPA)
 *
 * PROYECTO:  COMPRAS
 * PROPOSITO: Consultar el detalle de cada procedimiento para un proveedor logeado.
 *
 * AUTOR:     FZALDIVAR
 * FECHA:     21/Oct/2019
 *
*/
import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { ApiProcedimientosService } from 'src/app/services/api-procedimientos.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiDownloadFileService } from 'src/app/services/api-download-file.service';
import { isNullOrUndefined } from 'util';
import { Globals } from 'src/app/globals';
import { Proveedor } from 'src/app/models/Proveedor';
import { ApiAuthService } from 'src/app/services/api-auth.service';
import { ApiRegistryService } from 'src/app/services/api-registry.service';
import { DatePipe } from '@angular/common';
import { ApiUploadFileService } from 'src/app/services/api-upload-file.service';
declare var $: any;

@Component({
  selector: 'infoGral-producto',
  templateUrl: './infoGral-producto.component.html',
  styleUrls: ['./infoGral-producto.component.css']
})
export class InfoGralProductoComponent implements OnInit {
  public datosGrales: any[] = [];
  public articulos: any[] = [];
  public anexos: any[] = [];
  public pipe = new DatePipe('es');
  public files: FileList;

  @Input() public anio: string;
  @Input() public idProc: string;

  @Output() EventoMenu = new EventEmitter();
  @Output() EventoView = new EventEmitter();

  @ViewChild('myInputFile', {static: false}) myInputFile: ElementRef;

  public mensajeError: string = '¡Error!';
  public error: number;
  public aceptar: boolean = false;
  public showDeclina: boolean = false;

  private KeysFiles: {
    anio: string,
    idProcedimiento: string,
    idPartida: string
  }

  constructor(private apiProcedimientos: ApiProcedimientosService, private ruta: ActivatedRoute, private apiRegistry: ApiRegistryService,
              private apiDownload: ApiDownloadFileService, private router: Router, public globals: Globals,
              private apiAuth: ApiAuthService, private apiUpload: ApiUploadFileService) {
  }

  ngOnInit(): void {
    $('#mod_procesando').modal('show');
    //this.readDatosGrales(this.anio, this.idProc);
    if (!isNullOrUndefined(this.anio) && !isNullOrUndefined(this.idProc)) {
      this.readDatosGrales(this.anio, this.idProc);
    }
  }

  actualizarMenu(valor: string){
    /*Actualiza MENU de menu-producto.component.ts*/
    this.EventoMenu.emit({estatusProveedorProceso: valor});
  }

  redirectSubirCotiza(){
    this.EventoView.emit();
  }

  readDatosGrales(anio: string, idProcedimiento: string) {
    let proveedor;
    let prov: Proveedor = this.getProveedor();

    //$('#texto_error').text('Ocurrió un error al mostrar la información del procedimiento.');
    this.apiRegistry.getInformacionRfc(prov.RFC).subscribe(data => {
      if(data[0].success && data[0].info !== '{}' && data[0].info !== '[]'){
        proveedor = JSON.parse(data[0].info);

        this.apiProcedimientos.getDatosGralesProv(anio, idProcedimiento, proveedor[0].PK_FKCPRCO).subscribe(data => {
          if(data[0].success){
            this.datosGrales = JSON.parse(data[0].info);
            //console.log("Datos Generales", this.datosGrales);

            /*Si aun no tiene fecha interes, cambia de estatus a: "PROVEEDOR MOSTRO INTERES" y actualiza fecha*/
            if (this.datosGrales[0].FECHAINTERES === '' || this.datosGrales[0].FECHAINTERES === null) {
              let fechaActual = new Date();

              this.apiProcedimientos.updateProcesoProveedor(anio, idProcedimiento, proveedor[0].PK_FKCPRCO, this.globals.ESTATUS_PROC_PROV_INTERES, null, null, null, null, this.pipe.transform(fechaActual, 'dd/MM/yyyy'))
              .subscribe(data => {
                if (data[0].success) {
                  this.datosGrales[0].FKDPRPR_ESTADO = this.globals.ESTATUS_DESC_PROC_PROV_INTERES;
                  this.datosGrales[0].FKDPRPR_INDEST = this.globals.ESTATUS_PROC_PROV_INTERES;
                }
              });
            }

            /*Si la fecha de publicación terminó o es nula y el estatus es: "ESTATUS_PROC_PROV_PARTICIPANDO", entonces enviar -1 para no habilitar menu "Subir Cotización"*/
            let fechaActual = new Date();
            let fechaFinPub = new Date(this.datosGrales[0].FECFINPUB);

            if (this.datosGrales[0].FKDPRPR_INDEST == this.globals.ESTATUS_PROC_PROV_PARTICIPANDO &&
                (isNaN(fechaFinPub.getTime()) || fechaFinPub.getTime() < fechaActual.getTime())){
              this.actualizarMenu('-1');

            } else {
              this.actualizarMenu(this.datosGrales[0].FKDPRPR_INDEST);
            }

            this.readArticulos(anio, idProcedimiento, proveedor[0].PK_FKCPRCO);
          } else {
            this.mensajeError = data[0].msgRespuesta;
            setTimeout(() => {
              $('#mod_procesando').modal('hide');
              $('#error').modal('show');
            }, 500);
          }
        },
        error => {
          this.error = error.status;
          if (error.status === 401) {
            this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
          } else  {
            this.mensajeError = '¡Error!';
          }
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
          }, 500);
        });
      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
    });
  }

  readArticulos(anio: string, idProcedimiento: string, proveedor: string) {
    this.apiProcedimientos.getArticulosProv(anio, idProcedimiento, proveedor).subscribe(data => {
      if(data[0].success){
        this.articulos = JSON.parse(data[0].info);
        //console.log("Articulos", this.articulos);
        this.viewDeclinacion();

        /*Si la tabla ya fue inicializa se destruye*/
        if ($.fn.dataTable.isDataTable('#tbl_partidas')) {
          $('#tbl_partidas').DataTable().destroy();
        }

        $(document).ready(function () {
          let tbl_partidas = $('#tbl_partidas').DataTable({
            /*dom: "<'row'<'col-sm-12 col-md-6'l> <'col-sm-12 col-md-6 toolbar'>>" +
                  "<'row'<'col-sm-12'tr>>" +
                  "<'row'<'col-sm-12 col-md-6'><'col-sm-12 col-md-6'p>>",*/
             //dom: '<"#positionFilter">ltp',
        paging: true,       //Oculta controles y etiquetas de paginación
        searching: true,    //Dejar en true para conservar funcionalidades de busqueda en columnas.
        info: false,        //Oculta etiquetas de cantidad de registros disponibles y filtrados.
        autoWidth: false,   //Impide que calcule automaticamente el ancho de las columnas.
        processing: true,
        bSort: false,
        renderer: 'bootstrap',
        dom: "<'row'<'col-sm-10'B><'col-sm-2 toolbar'>>tp",
        "lengthMenu": [[10, 25, 50, -1], ["Mostrar 10", "Mostrar 25", "Mostrar 50", "Mostrar Todos"]],
        language: {
          "sSearch": "Buscar:",
          "sProcessing": "Procesando...",
          "sLengthMenu": "_MENU_ REGISTROS",
          "sZeroRecords": "No se encontraron resultados",
          "sEmptyTable": "Ningún dato disponible en esta tabla",
          "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
          "sInfoPostFix": "",
          "oPaginate": {
              "sFirst": "Primero",
              "sLast": "Último",
              "sNext": "SIGUIENTE",
              "sPrevious": "ANTERIOR"
          },
          buttons: {
              pageLength: {
                  _: '<span><i class="fal fa-list-ul mr-2"></i></span> %d REGISTROS',
                  //1: '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos',
                  '-1': '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos'
              }
          }
      },
      buttons: [
            {
              extend: 'pageLength',
              className: 'btn uaa-btn-outline btn-sm dropdown-toggle'
          }
      ]
          });

          $("div.toolbar").html('<span class="uaa-cgreen float-right"><i class="mdi mdi-trophy-award uaa-trophy"></i>= Indica que usted ha sido pre-asignado en la partida</span>');

          $('#txt_partidas').on( 'keyup', function () {
            tbl_partidas.search( this.value ).draw();
          });
        })

        this.readAnexos(this.datosGrales[0].IACTIDO_PK_CVETID, anio, idProcedimiento);
      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
    });
  }

  readAnexos(iActido: string, anio: string, idProcedimiento: string) {
    this.apiProcedimientos.getAnexos(iActido, anio, idProcedimiento).subscribe(data => {
      if(data[0].success){
        this.anexos = JSON.parse(data[0].info);
        //console.log("Anexos", this.anexos);

        /*Si la tabla ya fue inicializa se destruye*/
        if ($.fn.dataTable.isDataTable('#tbl_anexos')) {
          $('#tbl_anexos').DataTable().destroy();
        }

        $(document).ready(function () {
          let tbl_anexos = $('#tbl_anexos').DataTable({
            /*dom: "<'row'<'col-sm-12 col-md-6'l>>" +
                  "<'row'<'col-sm-12'tr>>" +
                  "<'row'<'col-sm-12 col-md-6'><'col-sm-12 col-md-6'p>>",*/
             //dom: '<"#positionFilter">ltp',
        paging: true,       //Oculta controles y etiquetas de paginación
        searching: true,    //Dejar en true para conservar funcionalidades de busqueda en columnas.
        info: false,        //Oculta etiquetas de cantidad de registros disponibles y filtrados.
        autoWidth: false,   //Impide que calcule automaticamente el ancho de las columnas.
        processing: true,
        bSort: false,
        renderer: 'bootstrap',
        dom: "<'row'<'col-sm-10'B><'col-sm-2'>>tp",
        "lengthMenu": [[10, 25, 50, -1], ["Mostrar 10", "Mostrar 25", "Mostrar 50", "Mostrar Todos"]],
        language: {
          "sSearch": "Buscar:",
          "sProcessing": "Procesando...",
          "sLengthMenu": "_MENU_ REGISTROS",
          "sZeroRecords": "No se encontraron resultados",
          "sEmptyTable": "Ningún dato disponible en esta tabla",
          "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
          "sInfoPostFix": "",
          "oPaginate": {
              "sFirst": "Primero",
              "sLast": "Último",
              "sNext": "SIGUIENTE",
              "sPrevious": "ANTERIOR"
          },
          buttons: {
              pageLength: {
                  _: '<span><i class="fal fa-list-ul mr-2"></i></span> %d REGISTROS',
                  //1: '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos',
                  '-1': '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos'
              }
          }
      },
      buttons: [
            {
              extend: 'pageLength',
              className: 'btn uaa-btn-outline btn-sm dropdown-toggle'
          }
      ]
          });

          $('#txt_anexos').on( 'keyup', function () {
            tbl_anexos.search( this.value ).draw();
          });
        })
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
        }, 500);

      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
    });
  }

  download(cve_docto: string) {
    this.apiDownload.downloadFile(cve_docto);
  }

  getProveedor(): Proveedor{
    let prov: Proveedor
    prov = this.apiAuth.getTokenDecoded();

    if (isNullOrUndefined(prov)) {
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
      return null;
    } else {
      return prov;
    }
  }

  participar(anio: string, idProcedimiento: string) {
    let proveedor: any[] = [];
    let prov: Proveedor = this.getProveedor();
    let fechaActual = new Date();

    $('#mod_terminos').modal('hide');
    $('#mod_procesando').modal('show');

    /*Si la fecha de publicación terminó o es nula, entonces enviar -1 para no habilitar menu "Subir Cotización"*/
    let fechaFinPub = new Date(this.datosGrales[0].FECFINPUB);

    if (isNaN(fechaFinPub.getTime()) || fechaFinPub.getTime() < fechaActual.getTime()){
      this.mensajeError = 'No puedes participar debido a que el tiempo de publicación a terminado.';
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);

      return;
    }

    this.apiRegistry.getInformacionRfc(prov.RFC).subscribe(data => {
      if(data[0].success && data[0].info !== '{}' && data[0].info !== '[]'){
        proveedor = JSON.parse(data[0].info);

        this.apiProcedimientos.updateProcesoProveedor(anio, idProcedimiento, proveedor[0].PK_FKCPRCO, this.globals.ESTATUS_PROC_PROV_PARTICIPANDO, null, null, null, null, null, this.pipe.transform(fechaActual, 'dd/MM/yyyy'))
        .subscribe(data => {
          if (data[0].success) {
            this.datosGrales[0].FKDPRPR_ESTADO = this.globals.ESTATUS_DESC_PROC_PROV_PARTICIPANDO;
            this.datosGrales[0].FKDPRPR_INDEST = this.globals.ESTATUS_PROC_PROV_PARTICIPANDO;
            this.actualizarMenu(this.globals.ESTATUS_PROC_PROV_PARTICIPANDO);
            this.redirectSubirCotiza();

            setTimeout(() => {
              $('#mod_procesando').modal('hide');
              //$('#mod_exito').modal('show');
            }, 1000);
          }else{
            this.mensajeError = data[0].msgRespuesta;
            setTimeout(() => {
              $('#mod_procesando').modal('hide');
              $('#error').modal('show');
            }, 500);
          }
        });

      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
    });
  }

  cerrarSesion() {
    this.apiAuth.deleteToken();
    this.router.navigate(['/']).then(() => window.location.reload());
  }

  aceptar_terminos(){
    if (this.aceptar){
      this.aceptar = false;
    } else {
      this.aceptar = true;
    }
  }

  declinar(){
    let proveedor: any[] = [];
    let prov: Proveedor = this.getProveedor();

    $('#mod_upload').modal('hide');

    if (this.files === undefined || this.files.length === 0) {
      setTimeout(() => {
        $('#p_alerta').text('¡No se ha seleccionado ningún archivo!');
        $('#mod_alerta').modal('show');
      }, 500);
      return;
    }

    $('#mod_procesando').modal('show');

    this.apiRegistry.getInformacionRfc(prov.RFC).subscribe(data => {
      if(data[0].success && data[0].info !== '{}' && data[0].info !== '[]'){
        proveedor = JSON.parse(data[0].info);

        this.apiUpload.declinaPartidas(this.KeysFiles.anio, this.KeysFiles.idProcedimiento, this.KeysFiles.idPartida, proveedor[0].PK_FKCPRCO, this.files[0])
        .subscribe(data => {
          if (data[0].success) {

            this.readArticulos(this.KeysFiles.anio, this.KeysFiles.idProcedimiento, proveedor[0].PK_FKCPRCO)
            this.clearFile();

            setTimeout(() => {
              $('#mod_procesando').modal('hide');
              $('#mod_exito').modal('show');
            }, 500);

          }else{
            this.mensajeError = data[0].msgRespuesta;
            setTimeout(() => {
              $('#mod_procesando').modal('hide');
              $('#error').modal('show');
            }, 500);

            this.clearFile();
          }
        });

      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);

        this.clearFile();
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);

      this.clearFile();
    });
  }

  saveKeysFiles(anio: string, idProcedimiento: string, idPartida: string) {
    this.KeysFiles = {
      anio:             anio,
      idProcedimiento:  idProcedimiento,
      idPartida:        idPartida
    }
  }

  clearFile() {
    this.myInputFile.nativeElement.value = '';
  }

  cargarArchivo(files: FileList) {
    this.files = files;
  }

  viewDeclinacion(){
    this.showDeclina = false;

    this.articulos.forEach(value => {
      //console.log(value);
      if (value.INDEST !== this.globals.ESTATUS_PROC_PROV_DECLINO &&
          value.DESCOFERTADA !== '' &&
          this.datosGrales[0].FKDPROC_INDEST === this.globals.ESTATUS_PROC_POR_ADJUDICAR){
        this.showDeclina = true;
      }
    });
  }

  abrirEnvioCorreo(){
    let correoContacto = 'asoledad@correo.uaa.mx'; // $(this).closest('tr').find('#hdn_correocont').val();
    this.correoLimpia();
    $('.correo').modal().show;

    this.correoAgregar(correoContacto);
  }

  correoLimpia(){
    $('.email-ids').remove();
    $(".enter-mail-id").val('');
    $(".enter-mail-id").css('border', '');
    $("#txt_para").val('');
    $("#txt_asunto").val('');
    $("#txt_mensaje").val('');
  }
   correoAgregar(strCorreo) {
    $('.all-mail').append('<span class="email-ids">' + strCorreo + '  <span hidden class="correos">' + strCorreo + ';</span>   <span class="cancel-email">x</span></span> ');
    $("#txt_para").val($('.correos').text().slice(0, -1));
  }

  correoAsunto(strCorreoAsunto) {
    $("#txt_asunto").val(strCorreoAsunto);
  }

 correoMensaje(strCorreoMensaje) {
    $("#txt_mensaje").val(strCorreoMensaje);
  }
  correoValida() {
      if ($("#txt_asunto").val() == null || $("#txt_asunto").val() == ""
          || $("#txt_mensaje").val() == null || $("#txt_mensaje").val() == ""
      ) return false;
      else return true;
  }

  correoEnviar() {
    if (this.correoValida()) {

    // $('#procesandocorreo').modal({ backdrop: 'static' });
    $('#mod_procesando').modal('show');
    let proveedor: any[] = [];
    let prov: Proveedor = this.getProveedor();

    this.apiRegistry.getInformacionRfc(prov.RFC).subscribe(data => {
      if(data[0].success && data[0].info !== '{}' && data[0].info !== '[]'){
        proveedor = JSON.parse(data[0].info);

        this.apiRegistry.enviarCorreos(proveedor[0].PK_FKCPRCO, this.anio, this.idProc, $("#txt_mensaje").val(), $("#txt_asunto").val() ).subscribe(data => {

          $('.correo').modal("hide");
          this.correoLimpia();
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
          }, 500);

          if (data[0].success) {
            setTimeout(() =>{
              $('#mod_procesando').modal('hide');
            }, 500);
            $('.correo').modal("hide");
            this.correoLimpia();
            $('#exitocorreo').modal("show");
        } else {
            setTimeout(()=> {
                $('#mod_procesando').modal('hide');
            }, 400);
            $('.correo').modal("hide");
            $('#emailtextoerror').text("Ocurrio un error al enviar el correo.");
            $('#errorcorreo').modal("show");
        }

        },
        error => {
          this.error = error.status;
          if (error.status === 401) {
            this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
          } else  {
            this.mensajeError = '¡Error!';
          }
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
          }, 500);
        });
      }
      },
      error => {
        this.error = error.status;
        if (error.status === 401) {
          this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
        } else  {
          this.mensajeError = '¡Error!';
        }
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);
      });
    } else {
      $('#emailtextoerror').text("Error: Falta capturar algun(os) dato(s) obligatorio(s), VERIFIQUE.");
      $('#errorcorreo').modal("show");
   }
  }


}
